// TODO To document.
export default new class AutoloadViews
{
    load(prefix, files, overrideFiles = null)
    {
        // Get possible override file names.
        let overrideFileNames = [];

        if (overrideFiles)
            overrideFiles.keys().forEach(fileName => overrideFileNames.push(fileName));

        // Loop files.
        files.keys().forEach(fileName =>
        {
            // Determine if has override.
            let hasOverride = overrideFileNames && overrideFileNames.indexOf(fileName) !== -1;

            // Access file, which means it will be loaded right now via Webpack.
            let fileSrc = hasOverride ? overrideFiles(fileName) : files(fileName);

            // Include override / Galaxy file of Javascript?
            if (fileName.split('.').pop() == 'vue')
                this.initVue(prefix, fileName, fileSrc);
        });
    }

    initVue(prefix, fileName, fileExport)
    {
        // TODO Doc
        // Format prefix?
        if (prefix) {

            // Support module::filename syntax, by converting it to module--filename.
            prefix = prefix.split('::').join('--');

            // Dot notation to kebab case.
            if(prefix.substr(-2, 2) != '--')
                prefix = prefix.split('.').join('-') + '-';
        }

        // Build tag by our convention.Vue.component(tag, fileExport.default);
        var formattedFilename = fileName.substr(2).split('.vue')[0].split('/').join('-');

        var tag = (prefix + /*'components-' +*/ formattedFilename).toLowerCase();

        // @debug Enable to see all registered tags.
        //console.info({ tag });

        // Register Vue component? Vue may be not included in website Concord module.
        if (window.Vue)
            Vue.component(tag, fileExport.default);
    }

    loadFromResourceComponentsOfConcordModules(files)
    {
        // Loop each files.
        files.keys().forEach(fileName =>
        {
            // Reference file so it will be loaded (magic).
            let fileSrc = files(fileName);

            // Abort due to no vue file? Referencing js was enought.
            if (fileName.split('.').pop() != 'vue')
                return;

            // Get Concord module id.
            let pieces = fileName.split('/');

            let concordModuleId = pieces[1].replace(/(?:^|\.?)([A-Z])/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "")

            // Determine hint path.
            let prefix = concordModuleId + '::';

            // Determine file, relative to Concord module's resources/components/ dir.
            fileName = './' + pieces.splice(4).join('/');

            // Init Vue tag.
            this.initVue(prefix, fileName, fileSrc);
        });
    }

};

// Fix images not loading in sliders. Somehow onload doesn't work there,
// so we need to execute the code ourselves. @ugly load on image load?
setTimeout(() => {

    let fixImageInterval = setInterval(() => {

        let imagesToFix = $('img[onload][sizes="1px"], img[onload][sizes="0vw"], img[onload][sizes="1vw"]');

        if (imagesToFix.length !== 0) {

            $.each(imagesToFix, function (index, value) {

                if (value.srcset.length <= 0) {
                    return;
                }

                if (value.offsetParent === null || !$(value).is(':visible')) {
                    return;
                }

                let size = value.getBoundingClientRect().width;

                if (!size) {
                    return;
                }

                $(value).attr('sizes', Math.ceil(size / window.innerWidth * 100) + 'vw');
            });
        }
    }, 500);

}, 1);
